import { useState, useContext, useEffect } from "react";
import { faturadorDateFilter, faturadorDateFilterMap } from "../../General/Format/faturador";
import { BiX } from "react-icons/bi";
import { UserContext } from "../../../contexts/userProvider";
import { ClientContext } from "../../../contexts/clientProvider";
import { FaturadorContext } from "../../../contexts/faturadorProvider";
import BaseCheckbox from "../../General/FormsComp/CheckBox";



const FilterDate = ({ closeModal, setFilterDates, checkUpdate, setCheckUpdate }) => {
  const { clienteSelecionado } = useContext(FaturadorContext);
  const { clientes } = useContext(ClientContext);
  const { setAlert } = useContext(UserContext);
  const [dataInicio, setDataInicio] = useState(null);
  const [dataFim, setDataFim] = useState(null);

  useEffect(() => {
    if (!clientes) return;
    const selectedClient = clientes.find((client) => client?.nome === clienteSelecionado);
    let inicio = selectedClient?.created_at.split('T')[0];
    setDataInicio(inicio);
    setDataFim(new Date().toISOString().split('T')[0]);
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "dataInicio") {
      setDataInicio(value);
    } else {
      setDataFim(value);
    }
  };

  const handleSaveClick = () => {
    let clienteSel = clientes.find((client) => client?.nome === clienteSelecionado);
    
    if (!dataInicio || !dataFim) {
      setAlert({ 
        visible: true, 
        title: "Atenção!", 
        placeholder: 'Preencha as datas corretamente.', 
        confirm: false, 
        type: "warning" 
      });
      return;
    }
  
    if (clienteSel && dataInicio < clienteSel.created_at.split('T')[0]) {
      setAlert({ 
        visible: true, 
        title: "Atenção!", 
        placeholder: 'A data inicial não pode ser menor que a data de cadastro do cliente.', 
        confirm: false, 
        type: "warning" 
      });
      return;
    }
  
    if (dataFim < dataInicio) {
      setAlert({ 
        visible: true, 
        title: "Atenção!", 
        placeholder: 'A data final não pode ser menor que a data inicial.', 
        confirm: false, 
        type: "warning" 
      });
      return;
    }

    if(dataFim > new Date().toISOString().split('T')[0]){
        setAlert({ 
            visible: true, 
            title: "Atenção!", 
            placeholder: 'A data final não pode ser maior que a data atual.', 
            confirm: false, 
            type: "warning" 
        });
        return;
    }
   
    setFilterDates({ dataInicio, dataFim, checkUpdate });
    closeModal();
  };
  

  const dados = faturadorDateFilter({ dataInicio, dataFim });
  const componentMap = faturadorDateFilterMap(
    handleInputChange,
    handleSaveClick,
    closeModal
  );

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-3xl shadow-vox-2xl max-w-md w-full mx-4 max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="bg-gradient-to-r from-vox-blue-600 to-vox-blue-800 px-6 py-6">
          <div className="flex items-center justify-between">
            <h1 className="text-xl font-bold text-white">Filtrar por data de implantação</h1>
            <button 
              onClick={() => closeModal()} 
              className="p-2 text-white hover:text-vox-green-300 hover:bg-white/10 rounded-lg transition-colors duration-200"
            >
              <BiX className="w-6 h-6" />
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6">
          <div className="space-y-6">
            {dados.map((dado, index) => (
              <div key={index} className="bg-gray-50 dark:bg-gray-700 rounded-xl p-4">
                {componentMap["Edit"](dado)}
              </div>
            ))}

            <div className="bg-vox-green-50 dark:bg-vox-green-900/20 border border-vox-green-200 dark:border-vox-green-700 rounded-xl p-4">
              <BaseCheckbox
                id="checkUpdate"
                name="checkUpdate"
                checked={checkUpdate}
                onChange={() => setCheckUpdate(!checkUpdate)}
                label="Busca por atualização do patrimônio"
                variant="primary"
                size="md"
              />
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-700">
          <div className="flex gap-3 justify-end">
            <button
              onClick={() => closeModal()}
              className="px-4 py-2 text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-600 border border-gray-300 dark:border-gray-500 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-500 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gray-500"
            >
              Cancelar
            </button>
            <button
              onClick={handleSaveClick}
              className="px-4 py-2 bg-gradient-to-r from-vox-green-600 to-vox-green-700 hover:from-vox-green-700 hover:to-vox-green-800 text-white font-medium rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-vox-green-500 focus:ring-offset-2"
            >
              Aplicar Filtro
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterDate;
